import { ObservableFromFetch } from "../ObservableFromFetch"
import CompanyUserCode from "./Model/ComapnyUserCode"

export default function GetCompanyUserCodes(accountID: number, userFieldType: string ) {
  const requestBody = JSON.stringify({
    AccountID: accountID,
    UserFieldType: userFieldType
  })
  return ObservableFromFetch<CompanyUserCode[]>("FFOrderClientFileMaintenance/GetCompanyUserCodes", requestBody)
}
export  function SaveCompanyUserCode(companyUserCode: CompanyUserCode) {
  const requestBody = JSON.stringify(companyUserCode)
  return ObservableFromFetch<CompanyUserCode>("FFOrderClientFileMaintenance/SaveCompanyUserCode", requestBody)
}
export  function DeleteCompanyUserCode(companyUserCode: CompanyUserCode) {
  const requestBody = JSON.stringify(companyUserCode)
  return ObservableFromFetch<number>("FFOrderClientFileMaintenance/DeleteCompanyUserCode", requestBody)
}
